import { render, staticRenderFns } from "./QueryEphedrineReport.vue?vue&type=template&id=15d63e04&scoped=true&"
import script from "./QueryEphedrineReport.vue?vue&type=script&lang=js&"
export * from "./QueryEphedrineReport.vue?vue&type=script&lang=js&"
import style0 from "./QueryEphedrineReport.vue?vue&type=style&index=0&id=15d63e04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d63e04",
  null
  
)

export default component.exports